import React from 'react';
import PropTypes from 'prop-types';

const ShipIcon = props => (
	<svg width="115" height="98" viewBox="0 0 115 98" fill="#F4817B" {...props}>
		<path d="M111.4 70.1h3.3v13.5h-12.3a13.5 13.5 0 0 1-27 0h-36a13.5 13.5 0 0 1-27 0h-9V77H0V70h75.4V36.4h13.8c5.1 0 9.5 3.4 10.7 8.3l3 12 8.5 4.4v9zm-85.5 18a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm63 0a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zM83.4 59h11.8l-3-12.2a3 3 0 0 0-3-2.3h-5.8v14.5zM51.2 20.6H71V41H41.6V20.6h-4.5V41H8V20.6h19.6a10.3 10.3 0 1 1 9.2-14.9l2.7 5.3L42 5.7a10.3 10.3 0 1 1 9.3 15zm-23.7-6h7l-3.1-6.2A4.2 4.2 0 0 0 27.7 6h-.2a4.3 4.3 0 0 0 0 8.6zm19.9-6.2l-3.1 6.2h7c1.5 0 3-.8 3.7-2.2a4.3 4.3 0 1 0-7.6-4zm-39.5 37H37v20.2H8V45.4zm33.7 0H71v20.2H41.6V45.4z"/>
	</svg>
);

export default ShipIcon;
